import { sendFormAsAjax } from './functions';

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".integration-page")) {
        const saveSecretForm = document.getElementById('save-zapier-secret');
        if (saveSecretForm) {
            saveSecretForm.addEventListener('submit', function(event) {
                event.preventDefault();

                sendFormAsAjax(this, 'PATCH', null, function(data) {
                    //
                });
            });
        }

        const saveSignalsWebhookUrlForm = document.getElementById('save-zapier-signals-webhook-url');
        if (saveSignalsWebhookUrlForm) {
            saveSignalsWebhookUrlForm.addEventListener('submit', function(event) {
                event.preventDefault();

                sendFormAsAjax(this, 'PATCH', null, function(data) {
                    //
                });
            });
        }

        ['btn-generate-secret', 'btn-copy-secret', 'btn-save-secret', 'btn-save-signals-webhook-url'].forEach(id => {
            const btn = document.getElementById(id);
            if (btn) {
                btn.addEventListener('click', function() {
                    this.classList.remove('btn-outline-primary');
                    this.classList.add('btn-outline-success');
                });
            }
        });
    }
});
